var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1899_1687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4683 4.03198C14.1271 3.69133 13.6647 3.5 13.1826 3.5C12.7005 3.5 12.2381 3.69133 11.8969 4.03198L3.73519 12.1939C3.50146 12.4263 3.31614 12.7028 3.18995 13.0073C3.06376 13.3118 2.9992 13.6383 3.00001 13.9679V14.9982C3.00001 15.1312 3.05288 15.2589 3.14699 15.353C3.2411 15.4471 3.36874 15.5 3.50184 15.5H4.53209C4.86167 15.5009 5.18816 15.4365 5.49267 15.3104C5.79717 15.1842 6.07363 14.999 6.30605 14.7653L14.4683 6.6029C14.8088 6.26175 15 5.79944 15 5.31744C15 4.83544 14.8088 4.37313 14.4683 4.03198ZM5.59647 14.0557C5.31344 14.3369 4.93102 14.4952 4.53209 14.4963H4.00366V13.9679C4.00316 13.7701 4.04188 13.5742 4.1176 13.3915C4.19331 13.2088 4.30452 13.0429 4.44477 12.9035L10.6388 6.70929L11.793 7.86352L5.59647 14.0557ZM13.7582 5.8933L12.5006 7.15141L11.3464 5.99718L12.6045 4.73907C12.7576 4.58601 12.9651 4.50002 13.1816 4.50002C13.2888 4.50002 13.3949 4.52113 13.4939 4.56215C13.5929 4.60316 13.6829 4.66328 13.7587 4.73907C13.8345 4.81486 13.8946 4.90483 13.9356 5.00385C13.9766 5.10287 13.9977 5.209 13.9977 5.31618C13.9977 5.42336 13.9766 5.5295 13.9356 5.62852C13.8946 5.72754 13.8345 5.81751 13.7587 5.8933H13.7582Z",
    fill: "#0090D3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1899_1687"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(3 3.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPen);
export default __webpack_public_path__ + "static/media/edit-pen.8bc11673b92f4ef9111e641c12a9a078.svg";
export { ForwardRef as ReactComponent };